export default __webpack_public_path__ + "static/gangli-ce01785c178f25fbb1902bb45a434ec3.png";